var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button as SemanticButton } from "semantic-ui-react";
import "../../styles/Button.module.scss";
var Button = function (props) { return _jsx(SemanticButton, __assign({}, props), void 0); };
export default Button;
